export default __webpack_public_path__ + "static/media/BlogPic2.3817177b.jpg";